import "./index.css";
import LoginPage from "LoginPage";
import React, { useEffect, useRef } from "react";

interface TypeInitializePanelProps {
  /**
   * @name onContinue 点击 “Continue” 按钮
   * @param email 用户输入的email
   */
  onContinue(params?: {
    /**
     * @param email
     */
    email: string;
    /**
     * @param fillIn 跳过邮箱验证流程
     */
    fillIn?: boolean;
  }): void;
  /**
   * @name onToSignUp 点击 “Sign up” 按钮
   */
  onToSignUp(type: "SIGNIN"): void;
  /**
   * @name onSuccess 快捷登录成功，通知刷新状态
   */
  onSuccess(): void;
}

/**
 * @name InitializePanel 初始化面板
 */
const InitializePanel: React.FC<TypeInitializePanelProps> = ({
  onSuccess,
  onToSignUp,
  onContinue,
}) => {
  const ref = useRef<HTMLDivElement>();

  // 禁止用户隐藏删除面板
  useEffect(() => {
    const el = ref.current;
    const parent = el?.parentElement;
    if (!el || !parent) return;
    const obs = new MutationObserver(() => {
      const isDeleted = !el.isConnected;
      const isHidden = window.getComputedStyle(el).display === "none";
      if (isDeleted || isHidden) {
        window.location.reload();
      }
    });
    obs.observe(parent, { childList: true });
    obs.observe(el, { attributes: true, attributeFilter: ["style", "class"] });
    return () => obs.disconnect();
  }, [ref.current]);

  // 防止用户打开控制台看数据
  // localStorage.setItem("NO_DEBUG", "1"); // 解禁
  // useEffect(() => {
  //   let intervalId: NodeJS.Timer;
  //   if (localStorage.getItem("NO_DEBUG")) return;
  //   intervalId = setInterval(() => {
  //     (function () {}).constructor("debugger")();
  //   });
  //   return () => clearInterval(intervalId);
  // }, []);

  // 用户引导用户注册，[需要填写email的确认code]
  function onEmailContinue(email: string) {
    onContinue({ email });
  }

  // 用户引导用户注册，[不需要填写email的确认code]
  function onSignUp(email?: string) {
    email ? onContinue({ email, fillIn: true }) : onToSignUp("SIGNIN");
  }

  return (
    <div ref={ref} className="ai-init-panel">
      <LoginPage
        onSuccess={onSuccess}
        onToSignUp={onSignUp}
        onContinue={onEmailContinue}
        continueText="Create account"
        title="Create a free account to unlock full answer"
        description={
          <>
            Already have an account?
            <span
              onClick={() => onToSignUp("SIGNIN")}
              style={{ color: "#325CEB", cursor: "pointer", marginLeft: 8 }}
            >
              Sign in
            </span>
          </>
        }
      />
    </div>
  );
};

export default InitializePanel;
